import { rest } from 'msw';

import {
  fetchProfileAvailabilityByUsername,
  submitProfileUsernameByUserId,
  submitRecoveryEmailByUserId,
  submitRecoveryPhoneByUserId,
} from 'api/users';
import { getConfig } from 'shared/config';

import { customers, recoveryInformation, userProfileMy } from '.';

const usersAPI = `${getConfig().microServices?.host}/users`;
const customersAPI = `${getConfig().microServices?.host}/customers`;

let currentVerificationFlow: 'email' | 'mobile' | null = null;

export const handlers = [
  rest.get(`${customersAPI}/my`, (req, res, ctx) => res(ctx.json(customers))),
  rest.get(`${usersAPI}/profile/my`, (req, res, ctx) => res(ctx.json(userProfileMy))),
  rest.put(`${usersAPI}/:userId/profile/password`, (req, res) => {
    // Keeping this so it's easy to add if we want to test again

    // return res(
    //   ctx.status(400),
    //   ctx.json({
    //     type: 'http://www.nuuday.dk/mityousee/errors/InputValidationError',
    //     status: 400,
    //     detail:
    //       "Exception of type 'Nuuday.NextGen.UserProfile.Integrations.YsPro.Exceptions.YsProResponseException' was thrown.",
    //   }),
    // );

    return res();
  }),
  rest.put(`${usersAPI}/:userId/profile/username`, (req, res, ctx) => {
    type UpdateUser = ReturnType<typeof submitProfileUsernameByUserId>;
    const recoveryInformation: UpdateUser = Promise.resolve({
      correlationToken: 'mock-recovery/phone',
    });
    return res(ctx.json(recoveryInformation));
  }),
  rest.put(`${usersAPI}/:userId/recovery/email`, (req, res, ctx) => {
    type RecoverEmail = ReturnType<typeof submitRecoveryEmailByUserId>;
    const recoveryInformation: RecoverEmail = Promise.resolve({
      correlationToken: 'mock-recovery/email',
    });
    currentVerificationFlow = 'email';
    return res(ctx.json(recoveryInformation));
  }),
  rest.put(`${usersAPI}/:userId/recovery/phone`, (req, res, ctx) => {
    type RecoverPhone = ReturnType<typeof submitRecoveryPhoneByUserId>;
    const recoveryInformation: RecoverPhone = Promise.resolve({
      correlationToken: 'mock-recovery/phone',
    });
    currentVerificationFlow = 'mobile';
    return res(ctx.json(recoveryInformation));
  }),
  rest.get(`${usersAPI}/profile/:newUsername/availability`, (req, res, ctx) => {
    type UsernameAvailable = ReturnType<typeof fetchProfileAvailabilityByUsername>;
    const usernameAvailable: UsernameAvailable = Promise.resolve(true);
    return res(ctx.json(usernameAvailable));
  }),
  rest.get(`${usersAPI}/:userId/recovery`, (req, res, ctx) => res(ctx.json(recoveryInformation))),
  rest.post(`${usersAPI}/:userId/recovery/activate`, (req, res) => {
    // 200 OK - real response is 204
    if (currentVerificationFlow === 'email') {
      recoveryInformation.emailSettings = {
        ...recoveryInformation.emailSettings,
        isVerified: true,
      };
    }
    if (currentVerificationFlow === 'mobile') {
      recoveryInformation.phoneSettings = {
        ...recoveryInformation.phoneSettings,
        isVerified: true,
      };
    }
    return res();
  }),
  rest.post(`${usersAPI}/:userId/recovery/activate`, (req, res) => {
    // 200 OK - real response is 204
    return res();
  }),
];
